import React from 'react'
import Conditional from '../common/Conditional'

export interface IGreyBox {
  heading?: string
  children: React.ReactNode
}
const GreyBox = (props: IGreyBox) => {
  return (
    <div className="highlight grey">
      <Conditional if={props.heading}>
        <h3>{props.heading}</h3>
      </Conditional>
      {props.children}
    </div>
  )
}

export default GreyBox
